import { map, compact } from 'lodash';

export default function pluckSelectedProgramIds(selectedFields, programKey = 'program') {
  return compact(map(selectedFields, `${programKey}.value.id`));
}
